import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  readonly SHOW_MENSAJE_INICIAL = 'show-mensaje-inicial';
  readonly SHOW_MENSAJE_FIRMA_ELECTRONICA_INVALIDA = 'show-mensaje-firma-electronica-invalida';
  readonly DETALLE_SOLICITUD:string = "data-solicitud";
  readonly SOLICITUD_PSE:string = "solicitud-pse";

  constructor() { }

  get showMensajeInicial(): boolean {
    return JSON.parse(sessionStorage.getItem(this.SHOW_MENSAJE_INICIAL) ?? 'true');
  }

  set showMensajeInicial(value: boolean) {
    sessionStorage.setItem(this.SHOW_MENSAJE_INICIAL, JSON.stringify(value));
  }

  get showMensajeFirmaElectronicaInvalida(): boolean {
    return JSON.parse(sessionStorage.getItem(this.SHOW_MENSAJE_FIRMA_ELECTRONICA_INVALIDA) ?? 'true');
  }

  set showMensajeFirmaElectronicaInvalida(value: boolean) {
    sessionStorage.setItem(this.SHOW_MENSAJE_FIRMA_ELECTRONICA_INVALIDA, JSON.stringify(value));
  }

  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
